import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import { useNavigate } from 'react-router-dom';
import { getData, UpdateDataForm } from '../../../API/GlobalApi.js';
import { FilterContestant } from '../../../Component/Filter/FilterContestant.jsx';
import { useTableFade } from '../../../Utils/tableFadeHooks.js';
import Notifier from '../../../Utils/notify.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import SearchingBar from '../../../Utils/Searching.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';
import ContextShortDetails from './ContestShortDetails.js';
import { UploadContestData } from '../../../Component/Modals/UploadContestDatas.js';
import { copyToClipboard } from '../../../Utils/copyToClipboard.js';
import edit from '../../../assets/icons/editnew.svg';
import { EditContsetDetails } from './EditContest.js';
import Select from "react-select";
import { reactSelectStyles } from '../../../Utils/selectBoxStyle.js';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { formatLocalDate } from '../../../Utils/data&dateTime.js';

export const ContestantDashboard = () => {

    const [contestantParticipants, setContestantParticipants] = useState([])
    const [selectedParticipants, setselectedParticipants] = useState([]);
    const [selectedParticipantId, setSelectedParticipantId] = useState(null);


    const [filterContestant, setFilterContestant] = useState([])
    const pageSize = 10;
    const [currentPage, setCurrentPage] = useState(0); // Starts from 0
    const [totalCount, setTotalCount] = useState(0);
    const pageCounts = Math.ceil(totalCount / pageSize);
    const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filterQueryString, setFilterQueryString] = useState({});
    const [filtermodal, setfiltermodal] = useState(false);
    const [exportmodal, setExportmodal] = useState(false);
    const pageChangeRef = useRef(false);
    const handlePageChange = ({ selected }) => {
        triggerTableLoading();
         pageChangeRef.current = true; // mark that next effect is from pagination
        setCurrentPage(selected);
    };
    const [isSearching, setIsSearching] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [selectedStudent, setselectedStudent] = useState([]);
    const [filterLoading, setFilterLoading] = useState(false)
    const [openDataUpload, setOpenDataUpload] = useState(false)

    const [participantCounts, setParticipantCounts] = useState({
        complete: 0,
        scanned: 0,
        pending: 0,
    });
    const [refreshKey, setRefreshKey] = useState(0);

    const getContestDatas = async (
        page = 0,
        filters = filterQueryString,
    ) => {
        const pageNumber = page + 1;
        const queryParams = new URLSearchParams({
            ...filters,
            page: pageNumber,
        });
        queryParams.set("page", pageNumber);
        const url = `administration/contests/2/participants/?${queryParams.toString()}`;

        if (!skipSpinnerRef.current) {
            if (isInitialLoad) setIsLoading(true);
            else setSearchLoading(true);
        }
        try {
            const res = await getData(url);
            if (res?.results) {
                const results = res.results;
                setContestantParticipants(results)
                setTotalCount(res.count || 0)
                setFilterContestant(results)
                // ✅ store counts separately
                const completeCount = res.complete_count || 0;
                const scannedCount = res.scanned_count || 0;
                setParticipantCounts({
                    complete: completeCount,
                    scanned: scannedCount,
                    pending: (res.count || 0) - completeCount,
                });
            }

            // Auto-select first student
            if (res?.results?.length > 0) {
                let nextSelected = null;

                if (selectedParticipantId) {
                    nextSelected = res.results.find(
                        (item) => item.id === selectedParticipantId
                    );
                }

                // fallback only if selected item no longer exists
                if (!nextSelected) {
                    nextSelected = res.results[0];
                    setSelectedParticipantId(nextSelected?.id || null);
                }

                setselectedParticipants(nextSelected);
            } else {
                setselectedParticipants(null);
                setSelectedParticipantId(null);
            }

            return res;
        } catch (err) {
            Notifier.error(err);
            setContestantParticipants([]);
            setTotalCount(0);
            return null;
        } finally {
            if (!skipSpinnerRef.current) {
                if (isInitialLoad) {
                    setIsLoading(false);
                    setIsInitialLoad(false);
                } else {
                    setSearchLoading(false);
                }
                setFilterLoading(false);
            }

            skipSpinnerRef.current = false;

            // setFilterLoading(false);
        }
    };

    // useEffect(() => {
    //     if (isSearching && refreshKey === 0) return;
    //     getContestDatas(
    //         currentPage,
    //         filterQueryString,
    //     ).finally(() => stopTableLoading());

    // }, [currentPage, filterQueryString, refreshKey]);



    useEffect(() => {
    // Only skip API if search is active AND page change was NOT triggered
    if (isSearching && !pageChangeRef.current && refreshKey === 0) return;

    getContestDatas(currentPage, filterQueryString)
        .finally(() => {
            stopTableLoading();
            pageChangeRef.current = false; // reset after API call
        });
}, [currentPage, filterQueryString, refreshKey]);



    const statusOptions = [
        { label: "Pending", value: "pending" },
        { label: "Complete", value: "complete" },
    ];
    const contestModeOptions = [
        { label: "Online", value: "online" },
        { label: "Offline", value: "offline" },
    ];
    const invagilationsOptions = [
        { label: "Pending", value: "pending" },
        { label: "Complete", value: "complete" },
    ];
    const [selectedContestMode, setSelectedContestMode] = useState(null);
    const [selectedInvigilationsMode, setSelectedInvigilationsMode] = useState(null);

    const [selectedStatus, setSelectedStatus] = useState(null);              // pending or completed
    const [collegeOptions, setCollegeOptions] = useState([]);
    const [selectedCollege, setSelectedCollege] = useState([]);

    const getCollegeList = async () => {
        const res = await getData("administration/get-college-list/2/");

        if (Array.isArray(res?.colleges)) {
            const options = res.colleges
                .filter(Boolean)
                .map(college => ({
                    value: college,
                    label: college,
                }));

            setCollegeOptions(options);
        }
    };

    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection',
        },
    ]);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const [showCalendar, setShowCalendar] = useState(false);
    const isSelectingEndRef = useRef(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.date-range-wrapper')) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);


    useEffect(() => {
        getCollegeList();
    }, []);

    const navigate = useNavigate();
    const handleRowClick = (orgId, row) => {
        console.log("row.original", row.original)
        setSelectedParticipantId(orgId);
        setselectedParticipants(row.original);
    };



    const [openEditContestDetails, setOpenEditContestDetails] = useState(false)

    const handleEditClick = (id, row) => {
        setOpenEditContestDetails(true)
        setselectedParticipants(row?.original)

    }
    const columns = useMemo(
        () => [
            // {
            //     Header: <input type='checkbox' />,
            //     accessor: 'checkbox',
            //     Cell: ({ row }) => (
            //         <input type="checkbox" checked={row.isSelected} onChange={() => row.toggleRowSelected()}
            //             style={{ cursor: 'pointer' }} />
            //     ),
            // },
            {
                Header: "Form No",
                disableSortBy: true,
                accessor: 'id',
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleRowClick(row.original.id, row)}>
                        <p
                            style={{
                                textAlign: 'left',
                                color: '#222F3E',
                                fontWeight: 500,
                                margin: 0,
                                cursor: 'pointer',
                                textDecoration: 'underline'
                            }}
                            title="Copy Form Number"
                            onClick={(e) => {
                                e.stopPropagation(); // ✅ prevent row click
                                copyToClipboard(
                                    row.original.arct_roll_number,
                                    "Form number copied"
                                );
                            }}
                        >
                            {row.original.arct_roll_number}
                        </p>
                    </div>
                ),
            },
            {
                Header: "Name",
                disableSortBy: true,
                accessor: 'name',
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }} className="no-text-cursor"
                        onClick={() => handleRowClick(row.original.id, row)}>
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.name}
                        </p>

                    </div>
                ),
            },
            {
                Header: "School Name",
                disableSortBy: false,
                accessor: 'previous_institution',
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }} className="no-text-cursor"
                    >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.previous_institution}
                        </p>

                    </div>
                ),
            },
            // {
            //     Header: "Contest Name",
            //     accessor: 'contest_name',
            //     disableSortBy: true,
            //     Cell: ({ row }) => (
            //         <div className="no-text-cursor">
            //             <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
            //                 {row.original.contest_name}
            //             </p>
            //             {/* <p style={{ textAlign: 'left', margin: 0 }}>{row.original.permanent_registration_number ? row.original.permanent_registration_number : '-'}</p> */}
            //         </div>
            //     ),
            // },

            {
                Header: 'Contact number',
                disableSortBy: true,
                accessor: 'mobile',
                Cell: ({ row }) => (
                    <div className="no-text-cursor">
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.mobile}</p>
                    </div>
                )
            },

            {
                Header: 'Mode',
                disableSortBy: true,
                accessor: 'offline',
                Cell: ({ row }) => {
                    const isOffline = row.original.offline;

                    return (
                        <div className="no-text-cursor">
                            <p
                                style={{
                                    textAlign: 'left',
                                    margin: 0,
                                    fontWeight: 600,
                                    color: isOffline ? '#D92D20' : '#027A48', // optional colors
                                }}
                            >
                                {isOffline ? 'Offline' : 'Online'}
                            </p>
                        </div>
                    );
                },
            },
            // {
            //     Header: 'Invigilation',
            //     disableSortBy: true,
            //     accessor: 'is_scanned',
            //     Cell: ({ row }) => {
            //         const isScanned = row.original.is_scanned;

            //         return (
            //             <div className="no-text-cursor">
            //                 <p
            //                     style={{
            //                         textAlign: 'left',
            //                         margin: 0,
            //                         fontWeight: 600,
            //                         fontSize: '12px',
            //                         color: isScanned ? 'green' : '#D92D20', // green / red
            //                     }}
            //                 >
            //                     {isScanned ? 'Completed' : 'Pending'}
            //                 </p>
            //             </div>
            //         );
            //     },
            // },



            {
                Header: 'Payment Status',
                accessor: 'payment_completed',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const status = row.original.payment_completed;

                    const label = status ? 'SUCCESS' : 'PENDING';
                    const color = status ? '#2ECC71' : '#F39C12'; // green / orange

                    return (
                        <p style={{ textAlign: 'left', color, margin: 0 }} className="no-text-cursor">
                            {label}
                        </p>
                    );
                },
                Header: 'Status',
                accessor: 'status',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const status = row.original.status || '';
                    const statusLower = status.toLowerCase();

                    const statusColor =
                        statusLower === 'pending'
                            ? '#FF3B30'   // red
                            : statusLower === 'complete'
                                ? 'green' // green
                                : '#222F3E'; // default

                    return (
                        <div className="no-text-cursor">
                            <p
                                style={{
                                    margin: 0,
                                    color: statusColor,
                                    fontWeight: 500,
                                    textTransform: 'capitalize'
                                }}
                            >
                                {status}
                            </p>
                        </div>
                    );
                }
            },
            {
                Header: 'Action',
                disableSortBy: true,
                Cell: ({ row }) => {
                    return (
                        <div
                            style={{ display: 'flex', gap: '10px' }}
                            data-tooltip-id="vendor-tip"
                            data-tooltip-content="Actions"
                            title='Edit details'
                        >

                            <img
                                src={edit}
                                style={{ cursor: 'pointer' }}
                                alt="Edit"
                                onClick={() => handleEditClick(row.original.id, row)}
                                data-tooltip-id="vendor-tip"
                                data-tooltip-content="Edit Vendor"
                                title='Edit Details'
                            />
                        </div>

                    );
                }
            }
        ],
        []
    );


    // Dynamically choose data source
    const sourceData = useMemo(() => {
        return filterQueryString
            ? filterContestant
            : contestantParticipants;
    }, [contestantParticipants, filterContestant, filterQueryString]);



    const formattedData = useMemo(() => {
        return sourceData?.map((emp) => ({
            id: emp.id,
            contest_name: emp.contest_name || '',
            name: emp.name || '',
            father_name: emp.father_name || '',
            previous_institution: emp.previous_institution || '',
            intermediate_marks: emp.intermediate_marks || '',
            mobile: emp.mobile || '',
            aadhar: emp.aadhar || '',
            qr_code_id: emp.qr_code_id || '',
            status: emp.status || '',
            payment_completed: emp.payment_completed || '',
            is_aadhar_verified: emp.is_aadhar_verified || '',
            verified: emp.verified || '',
            arct_roll_number: emp.arct_roll_number || '',
            is_mobile_number_unique: emp.is_mobile_number_unique,
            complete_count: emp.complete_count,
            scanned_count: emp.scanned_count,
            is_scanned: emp.is_scanned,
            scanned_by: emp.scanned_by,
            scanned_at: emp.scanned_at,
            offline: emp.offline,
            admit_card_issued_at: emp.admit_card_issued_at,
            handleRowClick,
        })) || [];
    }, [sourceData]);


    const searchInputRef = useRef(null);

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);

    // const modalOpenQueryRef = useRef({
    //     page: 0,
    //     query: '',
    //     sortField: sortField,
    //     sortOrder: sortOrder,
    // });

    const handleExportExcel = async () => {
        // onFilter(searchQuery); 
        setExportmodal(true);
        // try {
        //     const urlWithParams = 'administration/contests/1/participants/export/'
        //     const blob = await getBlob(urlWithParams);
        //     const url = window.URL.createObjectURL(blob);
        //     const a = document.createElement('a');
        //     a.href = url;
        //     a.download = 'participants_contestants_export.xlsx';
        //     document.body.appendChild(a);
        //     a.click();
        //     a.remove();
        // } catch (error) {
        //     displayToast('❌ Excel export failed', 'danger');
        // }
    };

    const handleSetSearchResults = (data) => {
        console.log("Data", data)
        let results = [];
        let count = 0;

        if (Array.isArray(data)) {
            results = data;
            count = data.length;
        } else if (data?.results) {
            results = data.results;
            count = data.count || data.results.length;
        }
        console.log("results in search", results)
        // ✅ update correct filter state
        setFilterContestant(results);

        // ✅ update selected participant safely
        if (results.length > 0) {
            const stillExists = selectedStudent
                ? results.find(x => x.id === selectedStudent.id)
                : null;

            setselectedStudent(stillExists || results[0]);
        } else {
            setselectedStudent(null);
        }
    };

    const handleSearchValueChange = (value) => {
        setSearchValue(value);

        if (!value.trim()) {
            setFilterQueryString((prev) => {
                if (!prev || typeof prev !== 'object') return {};
                const { search, ...rest } = prev;
                return rest;
            });
            setIsSearchMode(false);
            setIsSearching(false);
            setCurrentPage(0);
        } else {
            // Add search key to existing filter
            setFilterQueryString((prev) => ({
                ...(prev || {}),
                search: value.trim(),
            }));
            setIsSearchMode(true);
            setIsSearching(true);
            setCurrentPage(0);
        }
    };

    const handleSort = (columnId, order) => {
        // console.log("columnid", columnId)

        // console.log("order", order)
        setFilterLoading(true);
        setCurrentPage(0);

        setFilterQueryString(prev => {
            const updated = { ...prev };

            if (order) {
                updated.sort = order; // 👈 EXACTLY what backend expects
            } else {
                delete updated.sort;
            }

            return updated;
        });
        // setRefreshKey(prev => prev + 1); // 🔥 trigger fetch
    };

 return (
    <>
        {isLoading ? (
            <TableSkeleton rows={10} columns={6} showHeader={true} />
        ) : (
            <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                position: "relative",
            }}>

                {/* ── FIXED: Title + Stats Card ── */}
                <div style={{ flexShrink: 0, padding: "0 12px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h2 className="main-heading">Contest Participants ({totalCount})</h2>
                        <div style={{ width: "400px" }}>
                            <div className="p-3 rounded shadow-sm"
                                style={{ background: "#fff", borderLeft: "4px solid #7F56DA" }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6 className="m-0" style={{ fontWeight: 600 }}>Participants Status</h6>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span><strong>Total:</strong> {totalCount}</span>
                                    <span style={{ color: "green" }}><strong>Admit Card:</strong> {participantCounts.complete}</span>
                                    <span style={{ color: "#22C55E" }}><strong>Invigilation:</strong> {participantCounts.scanned}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── FIXED: Search + Filters ── */}
                <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                    <div className="row align-items-center">
                        <div className="col-md-2 d-flex justify-content-end gap-2">
                            <SearchingBar
                                placeholder="Search"
                                url="administration/contests/2/participants/"
                                filterQueryString={filterQueryString}
                                setResults={handleSetSearchResults}
                                ref={searchInputRef}
                                setTotalCount={setTotalCount}
                                setFilterQueryString={setFilterQueryString}
                                setSearchLoading={setSearchLoading}
                                setCurrentPage={setCurrentPage}
                                setIsSearching={setIsSearching}
                                isSearching={isSearching}
                                setIsSearchMode={setIsSearchMode}
                                setSearchValue={handleSearchValueChange}
                                searchValue={searchValue}
                            />
                        </div>
                        <div className="col-md-10 d-flex justify-content-start gap-2 flex-wrap">
                            <div style={{ width: "200px" }}>
                                <Select
                                    options={statusOptions}
                                    value={selectedStatus}
                                    onChange={(option) => {
                                        setSelectedStatus(option);
                                        setFilterLoading(true);
                                        setFilterQueryString(prev => {
                                            const updated = { ...prev };
                                            if (option) { updated.status = option.value; }
                                            else { delete updated.status; }
                                            return updated;
                                        });
                                        setCurrentPage(0);
                                    }}
                                    isClearable
                                    placeholder="Status"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={reactSelectStyles}
                                />
                            </div>
                            <div style={{ width: "200px" }}>
                                <Select
                                    options={collegeOptions}
                                    value={selectedCollege}
                                    isMulti
                                    onChange={(options) => {
                                        setSelectedCollege(options);
                                        setFilterLoading(true);
                                        setFilterQueryString(prev => {
                                            const updated = { ...prev };
                                            if (options?.length > 0) { updated.college = options.map(opt => opt.value).join(","); }
                                            else { delete updated.college; }
                                            return updated;
                                        });
                                        setCurrentPage(0);
                                    }}
                                    isClearable
                                    placeholder="College Name"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        ...reactSelectStyles,
                                        control: (base, state) => ({
                                            ...reactSelectStyles.control(base, state),
                                            height: "45px", minHeight: "45px", flexWrap: "nowrap",
                                        }),
                                        valueContainer: (base) => ({
                                            ...reactSelectStyles.valueContainer(base),
                                            flexWrap: "nowrap", overflowX: "auto",
                                        }),
                                        multiValue: (base) => ({
                                            ...reactSelectStyles.multiValue(base), whiteSpace: "nowrap",
                                        }),
                                    }}
                                />
                            </div>
                            <div style={{ width: "200px" }}>
                                <Select
                                    options={contestModeOptions}
                                    value={selectedContestMode}
                                    onChange={(option) => {
                                        setSelectedContestMode(option);
                                        setFilterLoading(true);
                                        setFilterQueryString(prev => {
                                            const updated = { ...prev };
                                            if (option?.value) { updated.contest_mode = option.value === "online" ? "0" : "1"; }
                                            else { delete updated.contest_mode; }
                                            return updated;
                                        });
                                        setCurrentPage(0);
                                    }}
                                    isClearable
                                    placeholder="Mode"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        ...reactSelectStyles,
                                        control: (base, state) => ({
                                            ...reactSelectStyles.control(base, state),
                                            height: "45px", minHeight: "45px",
                                        }),
                                    }}
                                />
                            </div>
                            <div style={{ width: "200px" }}>
                                <Select
                                    options={invagilationsOptions}
                                    value={selectedInvigilationsMode}
                                    onChange={(option) => {
                                        setSelectedInvigilationsMode(option);
                                        setFilterLoading(true);
                                        setFilterQueryString(prev => {
                                            const updated = { ...prev };
                                            if (option?.value) { updated.is_scanned = option.value === "complete" ? "1" : "0"; }
                                            else { delete updated.is_scanned; }
                                            return updated;
                                        });
                                        setCurrentPage(0);
                                    }}
                                    isClearable
                                    placeholder="Invigilation"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        ...reactSelectStyles,
                                        control: (base, state) => ({
                                            ...reactSelectStyles.control(base, state),
                                            height: "45px", minHeight: "45px",
                                        }),
                                    }}
                                />
                            </div>

                            {/* Date Range */}
                            <div className="date-range-wrapper" style={{ position: "relative", width: "220px" }}>
                                <input
                                    type="text"
                                    readOnly
                                    className="form-control"
                                    placeholder="Select date range"
                                    value={
                                        dateRange[0]?.startDate && dateRange[0]?.endDate
                                            ? `${formatLocalDate(dateRange[0].startDate)} → ${formatLocalDate(dateRange[0].endDate)}`
                                            : ""
                                    }
                                    onClick={() => { setShowCalendar(true); isSelectingEndRef.current = false; }}
                                    style={{ height: "45px", cursor: "pointer", paddingRight: "30px" }}
                                />
                                <div style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                                    <svg viewBox="0 0 24 24" fill="none" height="22" width="22" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 9H21M7 3V5M17 3V5M6 13H8M6 17H8M11 13H13M11 17H13M16 13H18M16 17H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z" stroke="#7F56DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <div style={{
                                        position: "absolute", top: "50px", zIndex: 1000,
                                        background: "#fff", boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                        borderRadius: "6px", padding: "10px",
                                    }}>
                                        <DateRange
                                            ranges={dateRange}
                                            editableDateInputs
                                            moveRangeOnFirstSelection={false}
                                            rangeColors={["#7F56DA"]}
                                            onChange={(item) => {
                                                const { startDate, endDate } = item.selection;
                                                setDateRange([item.selection]);
                                                if (!isSelectingEndRef.current) { isSelectingEndRef.current = true; return; }
                                                if (startDate && endDate) {
                                                    setFilterLoading(true);
                                                    const formatDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                                                    setFilterQueryString(prev => ({ ...prev, start_date: formatDate(startDate), end_date: formatDate(endDate) }));
                                                    setCurrentPage(0);
                                                    setShowCalendar(false);
                                                }
                                            }}
                                        />
                                        <div style={{ marginTop: "8px", textAlign: "right" }}>
                                            <button type="button"
                                                onClick={() => {
                                                    setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
                                                    setFilterQueryString(prev => { const u = { ...prev }; delete u.start_date; delete u.end_date; return u; });
                                                    setCurrentPage(0);
                                                    setShowCalendar(false);
                                                }}
                                                style={{ padding: "4px 8px", fontSize: "12px", cursor: "pointer", borderRadius: "4px", border: "1px solid #ccc" }}
                                            >Clear</button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <button style={{ border: "1px solid #7F56DA", background: "none", height: "43px" }}
                                onClick={() => setOpenDataUpload(true)}>
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195" stroke="#7F56DA" strokeWidth="1.5" strokeLinecap="round" />
                                    <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="#7F56DA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                {/* ── SCROLLABLE BOTTOM: Table (left) + Details (right) ── */}
                <div style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden", padding: "0 12px" }}>

                    {/* LEFT: Table only scrolls */}
                    <div style={{
                        flex: "0 0 66.67%", maxWidth: "66.67%",
                        display: "flex", flexDirection: "column",
                        minHeight: 0, overflow: "hidden", paddingRight: "12px"
                    }}>
                        {filterLoading ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                                <SpinnerLoader />
                            </div>
                        ) : formattedData?.length > 0 ? (
                            <AdvanceTable
                                columns={columns}
                                pageCounts={pageCounts}
                                handlePageChange={handlePageChange}
                                selectedData={selectedStudent}
                                data={formattedData}
                                handleRowClick={handleRowClick}
                                currentPage={currentPage}
                                checkbox={false}
                                handleSort={handleSort}
                            />
                        ) : (!isLoading && !isSearchLoading && (
                            <div style={{
                                display: "flex", flexDirection: "column",
                                alignItems: "center", justifyContent: "center",
                                flex: 1, color: "#888", textAlign: "center",
                            }}>
                                No Students Found.
                            </div>
                        ))}
                    </div>

                    {/* RIGHT: Details Panel */}
                    <div className="shortdetails" style={{
                        flex: "0 0 33.33%", maxWidth: "33.33%",
                        display: "flex", flexDirection: "column",
                        overflow: "hidden",
                    }}>
                        {!filterLoading && selectedParticipants?.id && (
                            <ContextShortDetails
                                selectedDetails={selectedParticipants}
                                setselectedStudent={setselectedParticipants}
                                getActivityDatas={getContestDatas}
                                currentPage={currentPage}
                                setRefreshKey={setRefreshKey}
                                isSearchMode={isSearchMode}
                                filterQueryString={filterQueryString}
                                searchValue={searchValue}
                            />
                        )}
                    </div>
                </div>

                <TableLoaderOverlay isLoading={tableLoading} />
            </div>
        )}

        <UploadContestData isOpen={openDataUpload} onClose={() => setOpenDataUpload(false)} getContestDatas={getContestDatas} currentPage={currentPage} setRefreshKey={setRefreshKey} />
        <EditContsetDetails isOpen={openEditContestDetails} onClose={() => setOpenEditContestDetails(false)}
            selectedParticipants={selectedParticipants} selectedDetails={selectedParticipants}
            setselectedStudent={setselectedParticipants} getActivityDatas={getContestDatas}
            currentPage={currentPage} isSearchMode={isSearchMode} filterQueryString={filterQueryString}
            searchValue={searchValue} setRefreshKey={setRefreshKey}
        />
    </>
);
};

